var map = {
	"./add-shipment-icon": 405,
	"./add-shipment-icon.svg": 405,
	"./arrow": 406,
	"./arrow.svg": 406,
	"./attention": 407,
	"./attention.svg": 407,
	"./back-arrow": 408,
	"./back-arrow.svg": 408,
	"./bell": 410,
	"./bell-lg": 409,
	"./bell-lg.svg": 409,
	"./bell.svg": 410,
	"./black-arrow": 411,
	"./black-arrow.svg": 411,
	"./cargo-fetching": 412,
	"./cargo-fetching.svg": 412,
	"./chat": 413,
	"./chat.svg": 413,
	"./close": 415,
	"./close-small-white": 414,
	"./close-small-white.svg": 414,
	"./close.svg": 415,
	"./collapse-group-icon": 416,
	"./collapse-group-icon.svg": 416,
	"./complete-shipment": 417,
	"./complete-shipment.svg": 417,
	"./cost/container": 132,
	"./cost/container.svg": 132,
	"./cost/customs": 133,
	"./cost/customs.svg": 133,
	"./cost/sea": 134,
	"./cost/sea.svg": 134,
	"./cost/thc": 135,
	"./cost/thc.svg": 135,
	"./cost/truck": 136,
	"./cost/truck.svg": 136,
	"./details/attentions": 137,
	"./details/attentions.svg": 137,
	"./details/containers": 138,
	"./details/containers.svg": 138,
	"./details/conversations": 139,
	"./details/conversations.svg": 139,
	"./details/cost": 140,
	"./details/cost.svg": 140,
	"./details/documents": 141,
	"./details/documents.svg": 141,
	"./details/location": 142,
	"./details/location.svg": 142,
	"./details/updates": 143,
	"./details/updates.svg": 143,
	"./details/watchers": 144,
	"./details/watchers.svg": 144,
	"./document-needed": 418,
	"./document-needed.svg": 418,
	"./download": 420,
	"./download-sample": 419,
	"./download-sample.svg": 419,
	"./download.svg": 420,
	"./dropdown-arrow": 421,
	"./dropdown-arrow.svg": 421,
	"./export": 422,
	"./export.svg": 422,
	"./eye": 424,
	"./eye-gray": 423,
	"./eye-gray.svg": 423,
	"./eye.svg": 424,
	"./fetch": 425,
	"./fetch.gif": 425,
	"./filled-arrow-down": 426,
	"./filled-arrow-down.svg": 426,
	"./filter": 427,
	"./filter.svg": 427,
	"./flags/AD": 215,
	"./flags/AD.png": 215,
	"./flags/AD.svg": 428,
	"./flags/AE": 216,
	"./flags/AE.png": 216,
	"./flags/AE.svg": 429,
	"./flags/AF": 217,
	"./flags/AF.png": 217,
	"./flags/AF.svg": 430,
	"./flags/AL": 218,
	"./flags/AL.png": 218,
	"./flags/AL.svg": 431,
	"./flags/AM": 219,
	"./flags/AM.png": 219,
	"./flags/AM.svg": 432,
	"./flags/AO": 220,
	"./flags/AO.png": 220,
	"./flags/AO.svg": 433,
	"./flags/AR": 221,
	"./flags/AR.png": 221,
	"./flags/AR.svg": 434,
	"./flags/AS": 222,
	"./flags/AS.png": 222,
	"./flags/AS.svg": 435,
	"./flags/AT": 223,
	"./flags/AT.png": 223,
	"./flags/AT.svg": 436,
	"./flags/AU": 224,
	"./flags/AU.png": 224,
	"./flags/AU.svg": 437,
	"./flags/AW": 225,
	"./flags/AW.png": 225,
	"./flags/AW.svg": 438,
	"./flags/AZ": 226,
	"./flags/AZ.png": 226,
	"./flags/AZ.svg": 439,
	"./flags/BB": 227,
	"./flags/BB.png": 227,
	"./flags/BB.svg": 440,
	"./flags/BD": 228,
	"./flags/BD.png": 228,
	"./flags/BD.svg": 441,
	"./flags/BE": 229,
	"./flags/BE.png": 229,
	"./flags/BE.svg": 442,
	"./flags/BG": 230,
	"./flags/BG.png": 230,
	"./flags/BG.svg": 443,
	"./flags/BH": 231,
	"./flags/BH.png": 231,
	"./flags/BH.svg": 444,
	"./flags/BJ": 232,
	"./flags/BJ.png": 232,
	"./flags/BJ.svg": 445,
	"./flags/BL": 233,
	"./flags/BL.png": 233,
	"./flags/BL.svg": 446,
	"./flags/BN": 234,
	"./flags/BN.png": 234,
	"./flags/BN.svg": 447,
	"./flags/BR": 235,
	"./flags/BR.png": 235,
	"./flags/BR.svg": 448,
	"./flags/BS": 236,
	"./flags/BS.png": 236,
	"./flags/BS.svg": 449,
	"./flags/BY": 237,
	"./flags/BY.png": 237,
	"./flags/BY.svg": 450,
	"./flags/BZ": 238,
	"./flags/BZ.png": 238,
	"./flags/BZ.svg": 451,
	"./flags/CA": 239,
	"./flags/CA.png": 239,
	"./flags/CA.svg": 452,
	"./flags/CD": 240,
	"./flags/CD.png": 240,
	"./flags/CD.svg": 453,
	"./flags/CG": 241,
	"./flags/CG.png": 241,
	"./flags/CG.svg": 454,
	"./flags/CH": 242,
	"./flags/CH.png": 242,
	"./flags/CH.svg": 455,
	"./flags/CI": 243,
	"./flags/CI.png": 243,
	"./flags/CI.svg": 456,
	"./flags/CK": 244,
	"./flags/CK.png": 244,
	"./flags/CK.svg": 457,
	"./flags/CL": 245,
	"./flags/CL.png": 245,
	"./flags/CL.svg": 458,
	"./flags/CM": 246,
	"./flags/CM.png": 246,
	"./flags/CM.svg": 459,
	"./flags/CN": 247,
	"./flags/CN.png": 247,
	"./flags/CN.svg": 460,
	"./flags/CO": 248,
	"./flags/CO.png": 248,
	"./flags/CO.svg": 461,
	"./flags/CR": 249,
	"./flags/CR.png": 249,
	"./flags/CR.svg": 462,
	"./flags/CU": 250,
	"./flags/CU.png": 250,
	"./flags/CU.svg": 463,
	"./flags/CV": 251,
	"./flags/CV.png": 251,
	"./flags/CV.svg": 464,
	"./flags/CW": 252,
	"./flags/CW.png": 252,
	"./flags/CW.svg": 465,
	"./flags/CY": 253,
	"./flags/CY.png": 253,
	"./flags/CY.svg": 466,
	"./flags/CZ": 254,
	"./flags/CZ.png": 254,
	"./flags/CZ.svg": 467,
	"./flags/DE": 255,
	"./flags/DE.png": 255,
	"./flags/DE.svg": 468,
	"./flags/DJ": 256,
	"./flags/DJ.png": 256,
	"./flags/DJ.svg": 469,
	"./flags/DK": 257,
	"./flags/DK.png": 257,
	"./flags/DK.svg": 470,
	"./flags/DO": 258,
	"./flags/DO.png": 258,
	"./flags/DO.svg": 471,
	"./flags/DZ": 259,
	"./flags/DZ.png": 259,
	"./flags/DZ.svg": 472,
	"./flags/EC": 260,
	"./flags/EC.png": 260,
	"./flags/EC.svg": 473,
	"./flags/EE": 261,
	"./flags/EE.png": 261,
	"./flags/EE.svg": 474,
	"./flags/EG": 262,
	"./flags/EG.png": 262,
	"./flags/EG.svg": 475,
	"./flags/ER": 263,
	"./flags/ER.png": 263,
	"./flags/ER.svg": 476,
	"./flags/ES": 264,
	"./flags/ES.png": 264,
	"./flags/ES.svg": 477,
	"./flags/ET": 265,
	"./flags/ET.png": 265,
	"./flags/ET.svg": 478,
	"./flags/FI": 266,
	"./flags/FI.png": 266,
	"./flags/FI.svg": 479,
	"./flags/FJ": 267,
	"./flags/FJ.png": 267,
	"./flags/FJ.svg": 480,
	"./flags/FR": 268,
	"./flags/FR.png": 268,
	"./flags/FR.svg": 481,
	"./flags/GA": 269,
	"./flags/GA.png": 269,
	"./flags/GA.svg": 482,
	"./flags/GB": 270,
	"./flags/GB.png": 270,
	"./flags/GB.svg": 483,
	"./flags/GE": 271,
	"./flags/GE.png": 271,
	"./flags/GE.svg": 484,
	"./flags/GG": 272,
	"./flags/GG.png": 272,
	"./flags/GG.svg": 485,
	"./flags/GH": 273,
	"./flags/GH.png": 273,
	"./flags/GH.svg": 486,
	"./flags/GM": 274,
	"./flags/GM.png": 274,
	"./flags/GM.svg": 487,
	"./flags/GN": 275,
	"./flags/GN.png": 275,
	"./flags/GN.svg": 488,
	"./flags/GQ": 276,
	"./flags/GQ.png": 276,
	"./flags/GQ.svg": 489,
	"./flags/GR": 277,
	"./flags/GR.png": 277,
	"./flags/GR.svg": 490,
	"./flags/GT": 278,
	"./flags/GT.png": 278,
	"./flags/GT.svg": 491,
	"./flags/GU": 279,
	"./flags/GU.png": 279,
	"./flags/GU.svg": 492,
	"./flags/GW": 280,
	"./flags/GW.png": 280,
	"./flags/GW.svg": 493,
	"./flags/GY": 281,
	"./flags/GY.png": 281,
	"./flags/GY.svg": 494,
	"./flags/HK": 282,
	"./flags/HK.png": 282,
	"./flags/HK.svg": 495,
	"./flags/HN": 283,
	"./flags/HN.png": 283,
	"./flags/HN.svg": 496,
	"./flags/HR": 284,
	"./flags/HR.png": 284,
	"./flags/HR.svg": 497,
	"./flags/HT": 285,
	"./flags/HT.png": 285,
	"./flags/HT.svg": 498,
	"./flags/HU": 286,
	"./flags/HU.png": 286,
	"./flags/HU.svg": 499,
	"./flags/ID": 287,
	"./flags/ID.png": 287,
	"./flags/ID.svg": 500,
	"./flags/IE": 288,
	"./flags/IE.png": 288,
	"./flags/IE.svg": 501,
	"./flags/IL": 289,
	"./flags/IL.png": 289,
	"./flags/IL.svg": 502,
	"./flags/IN": 290,
	"./flags/IN.png": 290,
	"./flags/IN.svg": 503,
	"./flags/IQ": 291,
	"./flags/IQ.png": 291,
	"./flags/IQ.svg": 504,
	"./flags/IR": 292,
	"./flags/IR.png": 292,
	"./flags/IR.svg": 505,
	"./flags/IS": 293,
	"./flags/IS.png": 293,
	"./flags/IS.svg": 506,
	"./flags/IT": 294,
	"./flags/IT.png": 294,
	"./flags/IT.svg": 507,
	"./flags/JM": 295,
	"./flags/JM.png": 295,
	"./flags/JM.svg": 508,
	"./flags/JO": 296,
	"./flags/JO.png": 296,
	"./flags/JO.svg": 509,
	"./flags/JP": 297,
	"./flags/JP.png": 297,
	"./flags/JP.svg": 510,
	"./flags/KE": 298,
	"./flags/KE.png": 298,
	"./flags/KE.svg": 511,
	"./flags/KH": 299,
	"./flags/KH.png": 299,
	"./flags/KH.svg": 512,
	"./flags/KM": 300,
	"./flags/KM.png": 300,
	"./flags/KM.svg": 513,
	"./flags/KN": 301,
	"./flags/KN.png": 301,
	"./flags/KN.svg": 514,
	"./flags/KP": 302,
	"./flags/KP.png": 302,
	"./flags/KP.svg": 515,
	"./flags/KW": 303,
	"./flags/KW.png": 303,
	"./flags/KW.svg": 516,
	"./flags/KZ": 304,
	"./flags/KZ.png": 304,
	"./flags/KZ.svg": 517,
	"./flags/LB": 305,
	"./flags/LB.png": 305,
	"./flags/LB.svg": 518,
	"./flags/LC": 306,
	"./flags/LC.png": 306,
	"./flags/LC.svg": 519,
	"./flags/LK": 307,
	"./flags/LK.png": 307,
	"./flags/LK.svg": 520,
	"./flags/LR": 308,
	"./flags/LR.png": 308,
	"./flags/LR.svg": 521,
	"./flags/LT": 309,
	"./flags/LT.png": 309,
	"./flags/LT.svg": 522,
	"./flags/LU": 310,
	"./flags/LU.png": 310,
	"./flags/LU.svg": 523,
	"./flags/LV": 311,
	"./flags/LV.png": 311,
	"./flags/LV.svg": 524,
	"./flags/LY": 312,
	"./flags/LY.png": 312,
	"./flags/LY.svg": 525,
	"./flags/MA": 313,
	"./flags/MA.png": 313,
	"./flags/MA.svg": 526,
	"./flags/ME": 314,
	"./flags/ME.png": 314,
	"./flags/ME.svg": 527,
	"./flags/MG": 315,
	"./flags/MG.png": 315,
	"./flags/MG.svg": 528,
	"./flags/MM": 316,
	"./flags/MM.png": 316,
	"./flags/MM.svg": 529,
	"./flags/MQ": 317,
	"./flags/MQ.png": 317,
	"./flags/MQ.svg": 530,
	"./flags/MR": 318,
	"./flags/MR.png": 318,
	"./flags/MR.svg": 531,
	"./flags/MT": 319,
	"./flags/MT.png": 319,
	"./flags/MT.svg": 532,
	"./flags/MU": 320,
	"./flags/MU.png": 320,
	"./flags/MU.svg": 533,
	"./flags/MV": 321,
	"./flags/MV.png": 321,
	"./flags/MV.svg": 534,
	"./flags/MW": 322,
	"./flags/MW.png": 322,
	"./flags/MW.svg": 535,
	"./flags/MX": 323,
	"./flags/MX.png": 323,
	"./flags/MX.svg": 536,
	"./flags/MY": 324,
	"./flags/MY.png": 324,
	"./flags/MY.svg": 537,
	"./flags/MZ": 325,
	"./flags/MZ.png": 325,
	"./flags/MZ.svg": 538,
	"./flags/NA": 326,
	"./flags/NA.png": 326,
	"./flags/NA.svg": 539,
	"./flags/NC": 327,
	"./flags/NC.png": 327,
	"./flags/NC.svg": 540,
	"./flags/NE": 328,
	"./flags/NE.png": 328,
	"./flags/NE.svg": 541,
	"./flags/NG": 329,
	"./flags/NG.png": 329,
	"./flags/NG.svg": 542,
	"./flags/NI": 330,
	"./flags/NI.png": 330,
	"./flags/NI.svg": 543,
	"./flags/NL": 331,
	"./flags/NL.png": 331,
	"./flags/NL.svg": 544,
	"./flags/NO": 332,
	"./flags/NO.png": 332,
	"./flags/NO.svg": 545,
	"./flags/NU": 333,
	"./flags/NU.png": 333,
	"./flags/NU.svg": 546,
	"./flags/NZ": 334,
	"./flags/NZ.png": 334,
	"./flags/NZ.svg": 547,
	"./flags/OM": 335,
	"./flags/OM.png": 335,
	"./flags/OM.svg": 548,
	"./flags/PA": 336,
	"./flags/PA.png": 336,
	"./flags/PA.svg": 549,
	"./flags/PE": 337,
	"./flags/PE.png": 337,
	"./flags/PE.svg": 550,
	"./flags/PF": 338,
	"./flags/PF.png": 338,
	"./flags/PF.svg": 551,
	"./flags/PG": 339,
	"./flags/PG.png": 339,
	"./flags/PG.svg": 552,
	"./flags/PH": 340,
	"./flags/PH.png": 340,
	"./flags/PH.svg": 553,
	"./flags/PK": 341,
	"./flags/PK.png": 341,
	"./flags/PK.svg": 554,
	"./flags/PL": 342,
	"./flags/PL.png": 342,
	"./flags/PL.svg": 555,
	"./flags/PR": 343,
	"./flags/PR.png": 343,
	"./flags/PR.svg": 556,
	"./flags/PS": 344,
	"./flags/PS.png": 344,
	"./flags/PS.svg": 557,
	"./flags/PT": 345,
	"./flags/PT.png": 345,
	"./flags/PT.svg": 558,
	"./flags/PY": 346,
	"./flags/PY.png": 346,
	"./flags/PY.svg": 559,
	"./flags/QA": 347,
	"./flags/QA.png": 347,
	"./flags/QA.svg": 560,
	"./flags/RO": 348,
	"./flags/RO.png": 348,
	"./flags/RO.svg": 561,
	"./flags/RS": 349,
	"./flags/RS.png": 349,
	"./flags/RS.svg": 562,
	"./flags/RU": 350,
	"./flags/RU.png": 350,
	"./flags/RU.svg": 563,
	"./flags/SA": 351,
	"./flags/SA.png": 351,
	"./flags/SA.svg": 564,
	"./flags/SB": 352,
	"./flags/SB.png": 352,
	"./flags/SB.svg": 565,
	"./flags/SC": 353,
	"./flags/SC.png": 353,
	"./flags/SC.svg": 566,
	"./flags/SD": 354,
	"./flags/SD.png": 354,
	"./flags/SD.svg": 567,
	"./flags/SE": 355,
	"./flags/SE.png": 355,
	"./flags/SE.svg": 568,
	"./flags/SG": 356,
	"./flags/SG.png": 356,
	"./flags/SG.svg": 569,
	"./flags/SI": 357,
	"./flags/SI.png": 357,
	"./flags/SI.svg": 570,
	"./flags/SK": 358,
	"./flags/SK.png": 358,
	"./flags/SK.svg": 571,
	"./flags/SL": 359,
	"./flags/SL.png": 359,
	"./flags/SL.svg": 572,
	"./flags/SM": 360,
	"./flags/SM.png": 360,
	"./flags/SM.svg": 573,
	"./flags/SN": 361,
	"./flags/SN.png": 361,
	"./flags/SN.svg": 574,
	"./flags/SO": 362,
	"./flags/SO.png": 362,
	"./flags/SO.svg": 575,
	"./flags/SR": 363,
	"./flags/SR.png": 363,
	"./flags/SR.svg": 576,
	"./flags/SV": 364,
	"./flags/SV.png": 364,
	"./flags/SV.svg": 577,
	"./flags/SY": 365,
	"./flags/SY.png": 365,
	"./flags/SY.svg": 578,
	"./flags/TD": 366,
	"./flags/TD.png": 366,
	"./flags/TD.svg": 579,
	"./flags/TG": 367,
	"./flags/TG.png": 367,
	"./flags/TG.svg": 580,
	"./flags/TH": 368,
	"./flags/TH.png": 368,
	"./flags/TH.svg": 581,
	"./flags/TM": 369,
	"./flags/TM.png": 369,
	"./flags/TM.svg": 582,
	"./flags/TN": 370,
	"./flags/TN.png": 370,
	"./flags/TN.svg": 583,
	"./flags/TO": 371,
	"./flags/TO.png": 371,
	"./flags/TO.svg": 584,
	"./flags/TP": 372,
	"./flags/TP.png": 372,
	"./flags/TP.svg": 585,
	"./flags/TR": 373,
	"./flags/TR.png": 373,
	"./flags/TR.svg": 586,
	"./flags/TT": 374,
	"./flags/TT.png": 374,
	"./flags/TT.svg": 587,
	"./flags/TW": 375,
	"./flags/TW.png": 375,
	"./flags/TW.svg": 588,
	"./flags/TZ": 376,
	"./flags/TZ.png": 376,
	"./flags/TZ.svg": 589,
	"./flags/UA": 377,
	"./flags/UA.png": 377,
	"./flags/UA.svg": 590,
	"./flags/UG": 378,
	"./flags/UG.png": 378,
	"./flags/UG.svg": 591,
	"./flags/US": 379,
	"./flags/US.png": 379,
	"./flags/US.svg": 592,
	"./flags/UY": 380,
	"./flags/UY.png": 380,
	"./flags/UY.svg": 593,
	"./flags/UZ": 381,
	"./flags/UZ.png": 381,
	"./flags/UZ.svg": 594,
	"./flags/VE": 382,
	"./flags/VE.png": 382,
	"./flags/VE.svg": 595,
	"./flags/VN": 383,
	"./flags/VN.png": 383,
	"./flags/VN.svg": 596,
	"./flags/WS": 384,
	"./flags/WS.png": 384,
	"./flags/WS.svg": 597,
	"./flags/YE": 385,
	"./flags/YE.png": 385,
	"./flags/YE.svg": 598,
	"./flags/ZA": 386,
	"./flags/ZA.png": 386,
	"./flags/ZA.svg": 599,
	"./flags/ZM": 387,
	"./flags/ZM.png": 387,
	"./flags/ZM.svg": 600,
	"./header-logo": 601,
	"./header-logo.svg": 601,
	"./import": 602,
	"./import.svg": 602,
	"./inland": 603,
	"./inland.svg": 603,
	"./label": 604,
	"./label.svg": 604,
	"./land": 605,
	"./land.svg": 605,
	"./lens": 606,
	"./lens.svg": 606,
	"./line-separator": 607,
	"./line-separator.svg": 607,
	"./location-marker": 608,
	"./location-marker.svg": 608,
	"./logo-mini": 609,
	"./logo-mini.svg": 609,
	"./map": 610,
	"./map.svg": 610,
	"./marker": 611,
	"./marker.svg": 611,
	"./markers/current-location": 145,
	"./markers/current-location.svg": 145,
	"./markers/delayed-location": 146,
	"./markers/delayed-location.svg": 146,
	"./markers/delivered-location": 147,
	"./markers/delivered-location.svg": 147,
	"./markers/mix": 148,
	"./markers/mix.svg": 148,
	"./markers/pod": 149,
	"./markers/pod.svg": 149,
	"./markers/pol": 150,
	"./markers/pol.svg": 150,
	"./markers/sailing-location": 151,
	"./markers/sailing-location.svg": 151,
	"./markers/scheduled-location": 152,
	"./markers/scheduled-location.svg": 152,
	"./markers/sea": 153,
	"./markers/sea.svg": 153,
	"./markers/small-pod": 154,
	"./markers/small-pod.svg": 154,
	"./markers/small-pol": 155,
	"./markers/small-pol.svg": 155,
	"./metrics/price": 156,
	"./metrics/price.svg": 156,
	"./metrics/profit": 157,
	"./metrics/profit.svg": 157,
	"./metrics/search": 158,
	"./metrics/search.svg": 158,
	"./metrics/track": 159,
	"./metrics/track.svg": 159,
	"./no-attentions": 612,
	"./no-attentions.svg": 612,
	"./no-notification": 613,
	"./no-notification.svg": 613,
	"./note": 614,
	"./note.svg": 614,
	"./notification/attachment": 161,
	"./notification/attachment-read": 160,
	"./notification/attachment-read.svg": 160,
	"./notification/attachment.svg": 161,
	"./notification/price": 163,
	"./notification/price-read": 162,
	"./notification/price-read.svg": 162,
	"./notification/price.svg": 163,
	"./notification/update": 165,
	"./notification/update-read": 164,
	"./notification/update-read.svg": 164,
	"./notification/update.svg": 165,
	"./order-again": 615,
	"./order-again.svg": 615,
	"./panes/attentions": 166,
	"./panes/attentions.svg": 166,
	"./panes/containers": 167,
	"./panes/containers.svg": 167,
	"./panes/conversations": 168,
	"./panes/conversations.svg": 168,
	"./panes/cost": 169,
	"./panes/cost.svg": 169,
	"./panes/documents": 170,
	"./panes/documents.svg": 170,
	"./panes/location": 171,
	"./panes/location.svg": 171,
	"./panes/updates": 172,
	"./panes/updates.svg": 172,
	"./panes/watchers": 173,
	"./panes/watchers.svg": 173,
	"./remarks": 617,
	"./remarks-focus": 616,
	"./remarks-focus.svg": 616,
	"./remarks.svg": 617,
	"./sea": 656,
	"./sea.png": 656,
	"./sea.svg": 654,
	"./search/arrow": 174,
	"./search/arrow.svg": 174,
	"./search/calendar": 175,
	"./search/calendar.svg": 175,
	"./search/containers": 176,
	"./search/containers.svg": 176,
	"./search/destination": 177,
	"./search/destination.svg": 177,
	"./search/loading": 178,
	"./search/loading.svg": 178,
	"./search/pickup": 179,
	"./search/pickup.svg": 179,
	"./search/pier": 180,
	"./search/pier.svg": 180,
	"./search/to": 181,
	"./search/to.svg": 181,
	"./search/trade": 182,
	"./search/trade.svg": 182,
	"./share-shipment": 618,
	"./share-shipment.svg": 618,
	"./ship": 619,
	"./ship.svg": 619,
	"./shipping-instruction": 620,
	"./shipping-instruction.svg": 620,
	"./small-container": 621,
	"./small-container.svg": 621,
	"./small-sea": 622,
	"./small-sea.svg": 622,
	"./small-upload": 623,
	"./small-upload.svg": 623,
	"./star": 625,
	"./star-shipment": 624,
	"./star-shipment.svg": 624,
	"./star.svg": 625,
	"./starred-shipment": 626,
	"./starred-shipment.svg": 626,
	"./state/canceled": 183,
	"./state/canceled.svg": 183,
	"./state/completed": 184,
	"./state/completed.svg": 184,
	"./state/confirmed": 185,
	"./state/confirmed.svg": 185,
	"./state/containers_assigned": 186,
	"./state/containers_assigned.svg": 186,
	"./state/customs": 187,
	"./state/customs.svg": 187,
	"./state/delivered": 188,
	"./state/delivered.svg": 188,
	"./state/emptyreturn": 189,
	"./state/emptyreturn.svg": 189,
	"./state/gateout": 190,
	"./state/gateout.svg": 190,
	"./state/inland": 191,
	"./state/inland.svg": 191,
	"./state/pending": 192,
	"./state/pending.svg": 192,
	"./state/pick": 193,
	"./state/pick.svg": 193,
	"./state/pod": 194,
	"./state/pod.svg": 194,
	"./state/pol": 195,
	"./state/pol.svg": 195,
	"./state/sea": 196,
	"./state/sea.svg": 196,
	"./state/skipped": 197,
	"./state/skipped.svg": 197,
	"./state/small/attention": 100,
	"./state/small/attention.svg": 100,
	"./state/small/canceled": 101,
	"./state/small/canceled.svg": 101,
	"./state/small/completed": 102,
	"./state/small/completed.svg": 102,
	"./state/small/confirmed": 103,
	"./state/small/confirmed.svg": 103,
	"./state/small/container": 104,
	"./state/small/container.svg": 104,
	"./state/small/containers_assigned": 105,
	"./state/small/containers_assigned.svg": 105,
	"./state/small/customs": 106,
	"./state/small/customs.svg": 106,
	"./state/small/deal": 107,
	"./state/small/deal.svg": 107,
	"./state/small/delivered": 108,
	"./state/small/delivered.svg": 108,
	"./state/small/document": 109,
	"./state/small/document.svg": 109,
	"./state/small/emptyreturn": 110,
	"./state/small/emptyreturn.svg": 110,
	"./state/small/exchange": 111,
	"./state/small/exchange.svg": 111,
	"./state/small/gateout": 112,
	"./state/small/gateout.svg": 112,
	"./state/small/inland": 113,
	"./state/small/inland.svg": 113,
	"./state/small/news": 114,
	"./state/small/news.svg": 114,
	"./state/small/pending": 115,
	"./state/small/pending.svg": 115,
	"./state/small/pick": 116,
	"./state/small/pick.svg": 116,
	"./state/small/pod": 117,
	"./state/small/pod.svg": 117,
	"./state/small/pol": 118,
	"./state/small/pol.svg": 118,
	"./state/small/sea": 119,
	"./state/small/sea.svg": 119,
	"./state/small/skipped": 120,
	"./state/small/skipped.svg": 120,
	"./state/small/wait": 122,
	"./state/small/wait.svg": 122,
	"./state/small/wait_cargo_readiness": 121,
	"./state/small/wait_cargo_readiness.svg": 121,
	"./state/wait": 199,
	"./state/wait.svg": 199,
	"./state/wait_cargo_readiness": 198,
	"./state/wait_cargo_readiness.svg": 198,
	"./status-fetching": 627,
	"./status-fetching.svg": 627,
	"./table-expand": 628,
	"./table-expand.svg": 628,
	"./three-dots": 630,
	"./three-dots-focus": 629,
	"./three-dots-focus.svg": 629,
	"./three-dots.svg": 630,
	"./track-fetching": 631,
	"./track-fetching.svg": 631,
	"./transit/date-in": 200,
	"./transit/date-in.svg": 200,
	"./transit/date-out": 201,
	"./transit/date-out.svg": 201,
	"./transit/not-visited": 202,
	"./transit/not-visited.svg": 202,
	"./transit/pod": 203,
	"./transit/pod.svg": 203,
	"./transit/pol": 204,
	"./transit/pol.svg": 204,
	"./transit/transit": 205,
	"./transit/transit.svg": 205,
	"./transit/vessel": 206,
	"./transit/vessel.svg": 206,
	"./transit/visited": 207,
	"./transit/visited.svg": 207,
	"./update-icons/change": 208,
	"./update-icons/change.svg": 208,
	"./update-icons/deliver": 209,
	"./update-icons/deliver.svg": 209,
	"./update-icons/freight": 210,
	"./update-icons/freight.svg": 210,
	"./update-icons/gate": 211,
	"./update-icons/gate.svg": 211,
	"./update-icons/truck": 212,
	"./update-icons/truck.svg": 212,
	"./update-icons/upload": 213,
	"./update-icons/upload.svg": 213,
	"./upload": 634,
	"./upload-csv-track": 632,
	"./upload-csv-track.svg": 632,
	"./upload-document": 633,
	"./upload-document.svg": 633,
	"./upload.svg": 634,
	"./white-arrow-icon": 635,
	"./white-arrow-icon.svg": 635,
	"./world": 636,
	"./world.svg": 636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;